import BillingPlans from "@/modules/subscriptions/ui/components/BillingPlans"
import type { BillingPlanDto } from "@/modules/subscriptions/dtos/billing-plan.dto"
import { Button } from "@/modules/shared/ui/components/button"

interface RegisterOrganizationPlanStepProps {
  onPlanSelect: (plan: BillingPlanDto, yearly: boolean) => void
  onBack: () => void
  isProcessing: boolean
}

export function RegisterOrganizationPlanStep({
  onPlanSelect,
  onBack,
  isProcessing,
}: RegisterOrganizationPlanStepProps) {
  const handlePlanSelect = (plan: BillingPlanDto, yearly: boolean) => {
    onPlanSelect(plan, yearly)
  }

  return (
    <div className="max-w-6xl mx-auto">
      <BillingPlans onPlanSelect={handlePlanSelect} />
      <div className="flex justify-start mt-6">
        <Button
          variant="ghost"
          onClick={onBack}
          className="px-6 py-2 text-muted-foreground hover:text-foreground"
          disabled={isProcessing}
        >
          Back
        </Button>
      </div>
    </div>
  )
}
